/**
 * PhaseExplainer - Educational intro before each phase
 */

import { useEffect, useState } from 'react';
import './PhaseExplainer.css';

export default function PhaseExplainer({ 
  phase, 
  phaseNumber, 
  totalPhases, 
  onContinue, 
  onOpenMap 
}) {
  const [mounted, setMounted] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setMounted(true));
  }, []);

  if (!phase) return null;

  return (
    <div className={`phase-explainer ${mounted ? 'mounted' : ''}`}>
      {/* Background */}
      <div className="phase-explainer__bg">
        <div 
          className="phase-explainer__glow"
          style={{ '--phase-color': phase.color }}
        />
      </div>

      {/* Content */}
      <div className="phase-explainer__content">
        {/* Phase number */}
        <div className="phase-explainer__number">
          Phase {phaseNumber} of {totalPhases}
        </div>

        {/* Badge */}
        <div 
          className="phase-explainer__badge"
          style={{ background: `linear-gradient(135deg, ${phase.color} 0%, ${phase.color}dd 100%)` }}
        >
          <span className="phase-explainer__icon">{phase.icon}</span>
        </div>

        {/* Title */}
        <h1 className="phase-explainer__title">{phase.name}</h1>
        
        {/* Description */}
        <p className="phase-explainer__description">{phase.description}</p>

        {/* Stats */}
        <div className="phase-explainer__stats">
          <div className="phase-explainer__stat">
            <span className="phase-explainer__stat-label">MLU</span>
            <span className="phase-explainer__stat-value">{phase.mlu}</span>
          </div>
          <div className="phase-explainer__stat">
            <span className="phase-explainer__stat-label">Prompting</span>
            <span className="phase-explainer__stat-value">{phase.prompting}</span>
          </div>
          <div className="phase-explainer__stat">
            <span className="phase-explainer__stat-label">Type</span>
            <span className="phase-explainer__stat-value">{phase.operant}</span>
          </div>
        </div>

        {/* Expandable science section */}
        <button 
          className="phase-explainer__toggle"
          onClick={() => setShowDetails(!showDetails)}
        >
          {showDetails ? '▲ Hide Details' : '▼ For Parents & Therapists'}
        </button>

        {showDetails && (
          <div className="phase-explainer__details">
            <div className="phase-explainer__tip">
              <span className="phase-explainer__tip-icon">💡</span>
              <span className="phase-explainer__tip-text">{phase.parentTip}</span>
            </div>
          </div>
        )}

        {/* Buttons */}
        <div className="phase-explainer__buttons">
          <button 
            className="phase-explainer__btn phase-explainer__btn--start"
            onClick={onContinue}
          >
            Let's Go!
          </button>
          
          <button 
            className="phase-explainer__btn phase-explainer__btn--map"
            onClick={onOpenMap}
          >
            View Map
          </button>
        </div>
      </div>
    </div>
  );
}
